/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useRef } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { generateQueryString } from "@/utils/normalizers/product";

import styles from "./style";
import { getFullUrl } from "@/utils/htmlUtils";

const RangeFilter = ({ filter, mobile }) => {
  const router = useRouter();
  const { query } = router;
  const minValue = parseInt(filter.value.min, 10);
  const maxValue = parseInt(filter.value.max, 10);
  const minLabel = `${filter.name}: valor mínimo`;
  const maxLabel = `${filter.name}: valor máximo`;
  const [min, setMin] = useState(minValue);
  const [max, setMax] = useState(maxValue);
  const [timer, setTimer] = useState(null);
  const userInteractedFilter = useRef(false);

  const {
    selectedFilters,
    sort,
    searcherQuery,
    id,
  } = useSelector((state) => state.devicesList);
  const {
    totalNumberOfElements,
  } = useSelector((state) => state.devicesList.pagination);


  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  useEffect(() => {
    userInteractedFilter.current = false;
    const minValueSelected =
      selectedFilters[`min${capitalizeFirstLetter(filter.id)}`];
    const maxValueSelected =
      selectedFilters[`max${capitalizeFirstLetter(filter.id)}`];
    const Min = minValueSelected ? minValueSelected : minValue;
    const Max = maxValueSelected ? maxValueSelected : maxValue;
    setMin(parseInt(Min, 10));
    setMax(parseInt(Max, 10));
  }, [selectedFilters]);

  useEffect(() => {
    clearTimeout(timer);
    if (userInteractedFilter.current) {
      const newTimer = setTimeout(() => {
        let url;

        let selectedFiltersNew;
        if (min === minValue && max === maxValue) {
          const selectedFiltersClean = Object.keys(selectedFilters).reduce(
            (result, key) => {
              if (
                key !== `min${capitalizeFirstLetter(filter.id)}` &&
                key !== `max${capitalizeFirstLetter(filter.id)}`
              ) {
                result[key] = selectedFilters[key];
              }
              return result;
            },
            {}
          );
          selectedFiltersNew = selectedFiltersClean;
        } else {
          selectedFiltersNew = {
            ...selectedFilters,
            [`min${capitalizeFirstLetter(filter.id)}`]: min,
            [`max${capitalizeFirstLetter(filter.id)}`]: max,
          };
        }

        if (searcherQuery) {
          selectedFiltersNew.query = searcherQuery;
        }
        selectedFiltersNew.id = id;
        selectedFiltersNew.sort = sort;
        url = `${getFullUrl(`/${id}?${generateQueryString(
          selectedFiltersNew
        )}`, query)}`;
        if (mobile)
          router.replace(url, undefined, { shallow: true });
        else
          router.push(url, undefined, { shallow: true });
      }, 1000);

      setTimer(newTimer);

      return () => {
        clearTimeout(newTimer);
      };
    }
  }, [min, max]);

  const onSliderChange = (value) => {
    userInteractedFilter.current = true;
    setMin(value[0]);
    setMax(value[1]);
  };

  const onMinChange = (e) => {
    userInteractedFilter.current = true;
    if (e.target.value >= filter?.value?.min && e.target.value <= filter?.value?.max) {
      setMin(e.target.value);
    }
  };

  const onMaxChange = (e) => {
    userInteractedFilter.current = true;
    if (e.target.value >= filter?.value?.min && e.target.value <= filter?.value?.max) {
      setMax(e.target.value);
    }
  };

  if (totalNumberOfElements <= 1) {
    return null;
  }

  return (
    <div className="sliderFilterContainer">
      <Slider
        range
        ariaLabelForHandle={[minLabel, maxLabel]}
        value={[min, max]}
        defaultValue={[min, max]}
        min={minValue}
        max={maxValue}
        onChange={onSliderChange}
        className="styled-slider"
      />
      <div className="SliderFilterInputContainer">
        <input
          className="SliderFilterInput"
          type={"number"}
          aria-label={minLabel}
          value={min}
          onChange={onMinChange}
          min={filter.value.min}
          max={filter.value.max}
        />
        <div className="SliderFilterInputSeparator" />
        <input
          className="SliderFilterInput"
          type={"number"}
          aria-label={maxLabel}
          value={max}
          onChange={onMaxChange}
          min={filter.value.min}
          max={filter.value.max}
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RangeFilter;
